import {
	Directive,
	forwardRef
} from '@angular/core';
import {
	NG_VALIDATORS,
	AbstractControl,
	ValidationErrors
} from '@angular/forms';

import { validateIP } from 'rev-shared/util/IPAddressValidation';

@Directive({
	selector: '[vbIpAddress]',
	providers: [{
		provide: NG_VALIDATORS,
		useExisting: forwardRef(() => VbIpAddressDirective),
		multi: true
	}]
})
export class VbIpAddressDirective {

	public validate(control: AbstractControl): ValidationErrors {
		if (!control) {
			return null;
		}

		return validateIP(control.value) ? null : { vbIpAddress: true };
	}
}
